import React from 'react'
import { Tooltip as BootstrapTooltip } from 'reactstrap'
import { GlobalContextProviders } from '@/components/globalContextProviders'

class Tooltip extends React.PureComponent {
  constructor (props) {
    super(props)

    this.toggle = this.toggle.bind(this)
    this.state = {
      tooltipOpen: false
    }
  }

  toggle () {
    this.setState({
      tooltipOpen: !this.state.tooltipOpen
    })
  }

  render () {
    const { children, ...rest } = this.props
    return (
      <BootstrapTooltip delay={0} isOpen={this.state.tooltipOpen} toggle={this.toggle} {...rest}>
        <GlobalContextProviders>
          {children}
        </GlobalContextProviders>
      </BootstrapTooltip>
    )
  }
}

export default Tooltip



// WEBPACK FOOTER //
// ./src/components/Tooltip.js